// extracted by mini-css-extract-plugin
export default {"photo":"Account_photo__PPSOv","button":"Account_button__J2wO+"};